import { useModal } from "@/contexts";
import { createDate } from "@/utils";
import { useCheckCountState, useCheckInState, useCheckOutState } from "@shared/client";
import dayjs, { type Dayjs } from "dayjs";
import { useState } from "react";

export const useCheckDate = () => {
    const [isFirstClick, setIsFirstClick] = useState(true);
    const [maxDate, setMaxDate] = useState<Dayjs>();
    const [checkIn, setCheckIn] = useCheckInState();
    const [checkOut, setCheckOut] = useCheckOutState();
    const [fakeCheckIn, setFakeCheckIn] = useState<string>(checkIn);
    const [fakeCheckOut, setFakeCheckOut] = useState<string | undefined>(checkOut);
    const [checkCount, setCheckCount] = useCheckCountState();
    const { closeModal } = useModal();
    const { currentObj } = createDate();

    const handleLimitedDays = (targetDate: Dayjs, date: string) => {
        const differenceInDays = targetDate.diff(dayjs(fakeCheckIn), "day");
        const isWithinRange = differenceInDays <= 10;

        if (isWithinRange) {
            setFakeCheckOut(date);
            setMaxDate(undefined);
            setCheckIn(fakeCheckIn);
            setCheckOut(date);
            closeModal();
        }

        if (!isWithinRange) {
            alert("체크인 연박은 10박까지만 선택이 가능합니다.");
        }
    };

    const handleFirstClick = (date: string) => {
        setFakeCheckIn(date);
        setFakeCheckOut(undefined);
        setIsFirstClick(false);
        setCheckCount(1);
    };

    const onChangeColor = (date: string) => {
        const targetDate = dayjs(date).hour(0).minute(0).second(0).millisecond(0);

        if (isNaN(targetDate.get("date"))) return;
        const isCurrentDateValid = currentObj.valueOf() <= targetDate.valueOf();
        const isInHighThanTarget = dayjs(fakeCheckIn).valueOf() >= targetDate.valueOf();

        if (isFirstClick) {
            handleFirstClick(date);
            setMaxDate(dayjs(date).add(10, "day"));
        }

        if (checkCount === 0 && isCurrentDateValid) {
            setCheckCount(1);

            if (!fakeCheckOut && !isInHighThanTarget) {
                handleLimitedDays(targetDate, date);
            } else {
                setFakeCheckIn(date);
                setMaxDate(dayjs(date).add(10, "day"));
                setFakeCheckOut(undefined);
            }
        } else if (checkCount === 1 && isCurrentDateValid) {
            setCheckCount(0);

            if (isInHighThanTarget) {
                setFakeCheckIn(date);
                setMaxDate(dayjs(date).add(10, "day"));
                setFakeCheckOut(undefined);
            }

            if (!isInHighThanTarget) {
                if (fakeCheckOut) {
                    setFakeCheckIn(date);
                    setMaxDate(dayjs(date).add(10, "day"));
                    setFakeCheckOut(undefined);
                } else {
                    handleLimitedDays(targetDate, date);
                }
            }
        }
    };

    return { checkIn: fakeCheckIn, checkOut: fakeCheckOut, currentObj, maxDate, onChangeColor };
};
